import React, { useEffect, useState } from 'react';
import { getPanelCampaigns } from '../../utils/api';
import { PageTitle, Card, Table, Loading, Empty, Btn } from '../../components/UI';

const roasColor = (r) => r >= 3 ? '#55efc4' : r >= 1.5 ? '#ffd200' : '#ff6584';
const statusColor = { ACTIVE: '#55efc4', PAUSED: '#ffd200' };
const presets = ['today', 'yesterday', 'last_7d', 'last_30d', 'this_month'];

export default function ClientCampaigns() {
  const [campaigns, setCampaigns] = useState([]);
  const [loading, setLoading]     = useState(true);
  const [preset, setPreset]       = useState('this_month');

  useEffect(() => {
    setLoading(true);
    getPanelCampaigns(preset)
      .then(r => setCampaigns(r.data?.data?.campaigns || []))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [preset]);

  return (
    <div>
      <PageTitle title="📋 আমার Campaigns" sub="আপনার সব campaign এর performance" />

      <div style={{ display: 'flex', gap: 8, marginBottom: 20 }}>
        {presets.map(p => (
          <Btn key={p} color={preset === p ? '#6c63ff' : '#1e1e2e'} onClick={() => setPreset(p)}
            style={{ fontSize: 12, padding: '7px 14px' }}>
            {p}
          </Btn>
        ))}
      </div>

      <Card>
        {loading ? <Loading /> : campaigns.length === 0 ? <Empty msg="কোনো campaign নেই" /> : (
          <Table
            headers={['Campaign', 'Status', 'Spend', 'ROAS', 'Clicks', 'CTR']}
            rows={campaigns.map((c, i) => (
              <tr key={i}>
                <td style={{ padding: '14px 16px', borderBottom: '1px solid #1e1e2e' }}>
                  <div style={{ fontWeight: 600, fontSize: 14 }}>{c.name}</div>
                  <div style={{ fontSize: 11, color: '#6b6b80', marginTop: 2 }}>{c.id}</div>
                </td>
                <td style={{ padding: '14px 16px', borderBottom: '1px solid #1e1e2e' }}>
                  <span style={{ fontSize: 12, fontWeight: 700, color: statusColor[c.status] || '#6b6b80' }}>
                    ● {c.status}
                  </span>
                </td>
                <td style={{ padding: '14px 16px', borderBottom: '1px solid #1e1e2e', fontWeight: 700, color: '#a29bfe' }}>
                  ৳{parseFloat(c.spend || 0).toLocaleString()}
                </td>
                <td style={{ padding: '14px 16px', borderBottom: '1px solid #1e1e2e', fontWeight: 700, color: roasColor(parseFloat(c.roas)) }}>
                  {parseFloat(c.roas || 0).toFixed(2)}x
                </td>
                <td style={{ padding: '14px 16px', borderBottom: '1px solid #1e1e2e', fontSize: 14 }}>
                  {parseInt(c.clicks || 0).toLocaleString()}
                </td>
                <td style={{ padding: '14px 16px', borderBottom: '1px solid #1e1e2e', fontSize: 14, color: '#6b6b80' }}>
                  {parseFloat(c.ctr || 0).toFixed(2)}%
                </td>
              </tr>
            ))}
          />
        )}
      </Card>
    </div>
  );
}
